import { ScreenAuthForgot } from '@dms/screen'

export default ScreenAuthForgot
